(function () {
  const syncTabsAria = (contentSwiper, tabsSwiper) => {
    if (!contentSwiper || !tabsSwiper) return;

    const realIndex = contentSwiper.realIndex !== undefined ? contentSwiper.realIndex : 0;
    const realTabs = Array.from(tabsSwiper.slides).filter(
      (s) => !s.classList.contains('swiper-slide-duplicate')
    );

    realTabs.forEach((tab, i) => {
      const isActive = i === realIndex;
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    const realPanels = Array.from(contentSwiper.slides).filter(
      (s) => !s.classList.contains('swiper-slide-duplicate')
    );
  };

  const cleanupDuplicateAria = (tabsSwiper, contentSwiper) => {
    const duplicateTabs = Array.from(tabsSwiper.slides).filter(
      (s) => s.classList.contains('swiper-slide-duplicate')
    );
    for (const tab of duplicateTabs) {
      tab.removeAttribute('role');
      tab.removeAttribute('aria-selected');
      tab.removeAttribute('aria-controls');
      tab.removeAttribute('id');
      tab.setAttribute('tabindex', '-1');
      tab.setAttribute('aria-hidden', 'true');
    }

    const duplicatePanels = Array.from(contentSwiper.slides).filter(
      (s) => s.classList.contains('swiper-slide-duplicate')
    );
    for (const panel of duplicatePanels) {
      panel.removeAttribute('role');
      panel.removeAttribute('aria-labelledby');
      panel.removeAttribute('id');
      panel.setAttribute('aria-hidden', 'true');
    }
  };

  // Function to update tabs wrapper color scheme based on active content slide
  const updateTabsWrapperColorScheme = (contentSwiper, tabsWrapperElement, contentsWrapperElement) => {
    if (!contentSwiper || !tabsWrapperElement) return;

    // Use realIndex to handle loop mode correctly - this gives us the actual slide index
    const realIndex = contentSwiper.realIndex !== undefined ? contentSwiper.realIndex : contentSwiper.activeIndex;

    // Find the slide by its data-tab attribute to handle loop mode correctly
    const allSlides = Array.from(contentSwiper.slides);
    const activeSlide = allSlides.find(slide => {
      const tabIndex = slide.getAttribute('data-tab');
      return tabIndex && parseInt(tabIndex) === realIndex + 1;
    }) || contentSwiper.slides[realIndex];

    if (!activeSlide) return;

    const colorScheme = activeSlide.getAttribute('data-color-scheme') || 'background-2';

    // Remove all existing color scheme classes
    const colorSchemeClasses = Array.from(tabsWrapperElement.classList).filter(className => className.startsWith('color-'));
    colorSchemeClasses.forEach(className => {
      tabsWrapperElement.classList.remove(className);
    });

    // Add the new color scheme class
    tabsWrapperElement.classList.add(`color-${colorScheme}`);

    // Also update contents wrapper if provided
    if (contentsWrapperElement) {
      const contentsColorSchemeClasses = Array.from(contentsWrapperElement.classList).filter(className => className.startsWith('color-'));
      contentsColorSchemeClasses.forEach(className => {
        contentsWrapperElement.classList.remove(className);
      });
      contentsWrapperElement.classList.add(`color-${colorScheme}`);
    }
  };

  const getMaxTabWidth = (slides) => {
    if (!slides.length) return 0;

    const measurementContainer = document.createElement("div");
    measurementContainer.style.position = "absolute";
    measurementContainer.style.visibility = "hidden";
    measurementContainer.style.pointerEvents = "none";
    measurementContainer.style.left = "-9999px";
    measurementContainer.style.top = "0";
    measurementContainer.style.width = "max-content";
    document.body.appendChild(measurementContainer);

    let maxWidth = 0;

    for (const slide of slides) {
      const clone = slide.cloneNode(true);
      clone.style.width = "max-content";

      for (const paragraph of clone.querySelectorAll("p")) {
        paragraph.style.whiteSpace = "nowrap";
      }

      measurementContainer.appendChild(clone);
      maxWidth = Math.max(maxWidth, Math.ceil(clone.getBoundingClientRect().width));
      measurementContainer.removeChild(clone);
    }

    document.body.removeChild(measurementContainer);

    return maxWidth;
  };

  const slideshow = () => {
    document.querySelectorAll(".slideshow").forEach((block) => {
      let box = block.closest("section");
      let id = box.getAttribute("id");
      block = $(block);
      const autoplay = block.data("autoplay");
      const stopAutoplay = block.data("stop-autoplay");
      const delay = block.data("delay") * 1000;
      const speed = block.data("speed") * 1000;
      const effect = block.data("effect");

      let swiperParams = {
        speed: speed,
        keyboard: true,
        loop: true,
        a11y: false
      };

      let autoplayParams = autoplay ? {
        autoplay: {
          delay: delay,
          disableOnInteraction: false,
          pauseOnMouseEnter: stopAutoplay,
        },
      } : {};

      let swiperTextSelector = `#${id} .slideshow__tabs-wrapper`;
      let swiperTextElement = document.querySelector(swiperTextSelector);
      let swiperImgSelector = `#${id} .slideshow__contents-wrapper`;
      let swiperImgElement = document.querySelector(swiperImgSelector);

      if (!swiperTextElement || !swiperImgElement) return;
      if (swiperTextElement.swiper || swiperImgElement.swiper) return;

      const swiperText = new Swiper(swiperTextSelector, {
        ...swiperParams,
        setWrapperSize: true,
        //autoplay: false,
        // loop: true,
        spaceBetween: 0,
        direction: "horizontal",
        slidesPerView: "auto",
        //slideToClickedSlide: true,
        //loopedSlides: 4,
        allowTouchMove: false,

        breakpoints: {
          990: {
            allowTouchMove: true,
          },
          1600: {
            allowTouchMove: false,
            touchRatio: 0,
            keyboard: {
              enabled: false,
            },
          },
        },
        on: {
          init: function () {
            swiperTextElement.classList.add('first_step');

            const originalSlides = Array.from(this.slides).filter(
              slide => !slide.classList.contains('swiper-slide-duplicate')
            );
            const maxWidth = getMaxTabWidth(originalSlides);
            if (!maxWidth) return;

            for (const slide of this.slides) {
              slide.style.width = `${maxWidth}px`;
            }
          },
          slideChange: function () {
            swiperTextElement.classList.remove('first_step');
          }
        }
      });

      const swiperImg = new Swiper(swiperImgSelector, {
        pagination: {
          el: document.querySelector(`#${id} .swiper-pagination`),
          clickable: true,
        },
        ...swiperParams,
        ...autoplayParams,
        effect: effect,
        thumbs: {
          swiper: swiperText,
        },
        on: {
          init: function () {
            swiperImgElement.classList.add('first_step');
            box.style.setProperty('--bullet-duration', `${delay}ms`);
            updateTabsWrapperColorScheme(this, swiperTextElement, swiperImgElement);
            cleanupDuplicateAria(swiperText, this);
            syncTabsAria(this, swiperText);
          },
          slideChange: function () {
            box.style.setProperty('--bullet-duration', `${delay + speed}ms`);
            updateTabsWrapperColorScheme(this, swiperTextElement, swiperImgElement);
            syncTabsAria(this, swiperText);
          },
          slideChangeTransitionEnd: function () {
            swiperImgElement.classList.remove('first_step');
          }
        }
      });

      swiperTextElement.addEventListener('keydown', (e) => {
        if (e.code !== 'Enter' && e.code !== 'Space') return;
        const tab = e.target.closest('.slideshow__tab:not(.swiper-slide-duplicate)');
        if (!tab) return;
        e.preventDefault();
        const realTabs = Array.from(swiperText.slides).filter(
          (s) => !s.classList.contains('swiper-slide-duplicate')
        );
        const tabIndex = realTabs.indexOf(tab);
        if (tabIndex !== -1) swiperImg.slideToLoop(tabIndex);
      });

      if (autoplay && stopAutoplay) {
        swiperImgElement.addEventListener("mouseenter", function () {
          swiperTextElement.classList.add("stop_move");
        });
        swiperImgElement.addEventListener("mouseleave", function () {
          swiperTextElement.classList.remove("stop_move");
        });
      }

      if ($(block.find(".slideshow__content")).length === 1) {
        swiperImgElement.classList.add('no_slideshow');
        swiperTextElement.classList.add('no_slideshow');

        swiperImg.destroy(true, true);
        swiperText.destroy(true, true);
      }
    })
  }


  document.addEventListener("DOMContentLoaded", function () {
    slideshow();
    document.addEventListener("shopify:section:load", function () {
      slideshow();
    });
  });
})();